const CONTACT_IDS = [22, 21, 20, 19, 18];

export const createContactEmptyStateContent = t =>
  CONTACT_IDS.map((id, index) => {
    const position = index + 1;
    const key = `CONTACTS_EMPTY_STATE.EXAMPLES.CONTACT_${position}`;

    return {
      id,
      name: t(`${key}.NAME`),
      email: `${t('CONTACTS_EMPTY_STATE.EXAMPLES.EMAIL_PREFIX')}${position}@${t('CONTACTS_EMPTY_STATE.EXAMPLES.EMAIL_DOMAIN')}`,
      phoneNumber: t(`${key}.PHONE_NUMBER`),
      thumbnail: '',
      availabilityStatus: 'offline',
      additionalAttributes: {
        city: t(`${key}.CITY`),
        country: t('CONTACTS_EMPTY_STATE.EXAMPLES.COUNTRY_CODE'),
        countryCode: t('CONTACTS_EMPTY_STATE.EXAMPLES.COUNTRY_CODE'),
        countryName: t('CONTACTS_EMPTY_STATE.EXAMPLES.COUNTRY_NAME'),
        companyName: t(`${key}.COMPANY_NAME`),
      },
    };
  });
